import { z } from 'zod'
import { oc } from '@orpc/contract'

/**
 * Match Review retry search: the five Key Demographics as typed on the retry
 * screen, passed verbatim to the exact TEFCA (Health Gorilla) patient search.
 * Plain fields at the boundary — never FHIR resources.
 */

const keyDemographicsSchema = z.object({
  givenName: z.string().min(1),
  familyName: z.string().min(1),
  birthDate: z.string().min(1),
  gender: z.string().min(1),
  postalCode: z.string().min(1),
})

// Candidate fields mirror the search fields but stay unconstrained: a TEFCA
// record may carry fewer demographics than a search requires.
export const tefcaCandidateSchema = z.object({
  hgPatientId: z.string(),
  givenName: z.string(),
  familyName: z.string(),
  birthDate: z.string(),
  gender: z.string(),
  postalCode: z.string(),
})

export type TefcaRetrySearchCandidate = z.infer<typeof tefcaCandidateSchema>

export const tefcaRetrySearch = oc
  .route({ method: 'POST', path: '/v2/tefca/retry-search' })
  .input(keyDemographicsSchema)
  .output(z.object({ candidates: z.array(tefcaCandidateSchema) }))
